module.exports = __webpack_public_path__ + "static/media/Ear(L) v1.efd0021c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Ear(L) v1.png
// module id = 407
// module chunks = 0